import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const patient = {
  path: '/orderServiceTerm',
  component: Layout,
  name: 'orderServiceTerm',
  redirect: '/orderServiceTerm/index',
  children: [
    {
      path: '/orderServiceTerm/index',
      component: () => import('@/views/orderServiceTerm/index'),
      name: 'orderServiceTerm.index',
      meta: { title: i18n.t(`message.orderServiceTerm`)}
    },
  ]
}

export default patient